import React from 'react';
import ReactDOM from 'react-dom/client';
import DockBuoyancyCalculator from './dock-buoyancy-calculator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<DockBuoyancyCalculator />);
